import { useCallback, useContext } from 'react';
import _ from 'underscore';
import { odata } from '@bingads-webui/http-util';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';

const isCCError = response => response.ResultType === 1 || response.ResultType === 3;

export const useUpdateNotificationSettings = () => {
  const serverContext = useContext(ServerContext);
  const {
    CurrentCustomer: currentCustomer,
    CurrentAccount: currentAccount,
    CurrentUser: currentUser,
    ServicesEndpoints: { ClientCenterUIAPI: host },
    Token: token,
    Urls: { SignOutUrl = null } = {},
  } = serverContext;

  const uid = currentUser ? currentUser.Id : '';
  const cid = currentCustomer ? currentCustomer.Id : '';
  const aid = currentAccount ? currentAccount.Id : '';

  const updateNotificationSettings = useCallback((tc = {}) => {
    if (!uid || !cid) {
      return Promise.resolve();
    }

    const oDataOption = {
      cid,
      aid,
      uid,
      contentType: 'application/json',
      host,
      path: 'Settings',
      token,
      SignOutUrl,
    };

    const baseUrl = `EmailNotificationCategorySettings?id=${uid}&cid=${cid}&uid=${uid}`;

    const payload = {
      emailNotificationCategorySettings: {
        uid,
        NotificationCategorySettings: [],
        MarketingPreference: {
          AllowContactPreference: _.get(tc, 'AllowContact', true),
          ContactPreferenceEmail: _.get(tc, 'AllowContact', true),
          ContactPreferencePhone: _.get(tc, 'AllowContactByPhone', true),
          EmailFormat: '1',
        },
      },
    };

    const options = {
      ...oDataOption,
      url: baseUrl,
      data: payload,
    };

    return odata.patch(options)
      .then((response) => {
        if (isCCError(response)) {
          return Promise.reject(response);
        }

        return response;
      });
  }, [SignOutUrl, aid, cid, host, token, uid]);

  return {
    updateNotificationSettings,
  };
};
